import React, { useState, useEffect } from 'react';
import { addCustomSession, getCustomSessions, deleteCustomSession } from '../services/api';

const SessionModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    date: '',
    start_time: '09:15',
    end_time: '15:30',
    session_type: 'Mock Trading',
    description: ''
  });
  
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });
  
  const [sessionsList, setSessionsList] = useState([]);
  const [loadingSessions, setLoadingSessions] = useState(false);

  useEffect(() => {
    if (isOpen) {
      fetchExistingSessions();
    } else {
      setMessage({ type: '', text: '' });
    }
  }, [isOpen]);

  const fetchExistingSessions = async () => {
    setLoadingSessions(true);
    try {
      const response = await getCustomSessions();
      if (response.status && response.data) {
        setSessionsList(response.data);
      } else {
        setSessionsList([]);
      }
    } catch (error) {
      console.error("Failed to load existing sessions");
    } finally {
      setLoadingSessions(false);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ type: '', text: '' });

    try {
      const finalDescription = formData.description 
        ? `${formData.session_type} - ${formData.description}` 
        : formData.session_type;

      const payload = {
        date: formData.date,
        start_time: formData.start_time.length === 5 ? `${formData.start_time}:00` : formData.start_time,
        end_time: formData.end_time.length === 5 ? `${formData.end_time}:00` : formData.end_time,
        description: finalDescription
      };

      const response = await addCustomSession(payload);
      
      if (response.status) {
        setMessage({ type: 'success', text: response.message || 'Session added successfully!' });
        await fetchExistingSessions();
        setFormData({ date: '', start_time: '09:15', end_time: '15:30', session_type: 'Mock Trading', description: '' });
        setTimeout(() => setMessage({ type: '', text: '' }), 3000);
      } else {
        setMessage({ type: 'error', text: response.error || 'Failed to add session.' });
      }
    } catch (error) {
      setMessage({ type: 'error', text: 'Server error. Could not connect to the API.' });
    } finally {
      setLoading(false);
    }
  };

  // NEW: Function to handle session deletion
  const handleDelete = async (dateStr) => {
    // Safety check so the user doesn't accidentally click the trash can
    if (!window.confirm(`Are you sure you want to delete the session(s) scheduled for ${dateStr}?`)) {
      return;
    }

    setLoadingSessions(true);
    setMessage({ type: '', text: '' });

    try {
      const response = await deleteCustomSession(dateStr);
      if (response.status) {
        setMessage({ type: 'success', text: response.message || `Deleted session for ${dateStr}` });
        await fetchExistingSessions(); // Refresh the list
        setTimeout(() => setMessage({ type: '', text: '' }), 3000);
      } else {
        setMessage({ type: 'error', text: response.message || response.error || 'Failed to delete.' });
        setLoadingSessions(false);
      }
    } catch (error) {
      setMessage({ type: 'error', text: 'Server error during deletion.' });
      setLoadingSessions(false);
    }
  };

  const formatDate = (dateStr) => {
    const options = { month: 'short', day: 'numeric', year: 'numeric' };
    return new Date(dateStr).toLocaleDateString(undefined, options);
  };

  if (!isOpen) return null;

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <div style={headerStyle}>
          <h3 style={{ margin: 0, color: '#fff' }}>Schedule Special Session</h3>
          <button onClick={onClose} style={closeButtonStyle} title="Close">✕</button>
        </div>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
          
          {message.text && (
            <div style={{
              padding: '10px', borderRadius: '4px', fontSize: '0.9rem',
              backgroundColor: message.type === 'success' ? 'rgba(38, 166, 154, 0.2)' : 'rgba(239, 83, 80, 0.2)',
              color: message.type === 'success' ? '#26a69a' : '#ef5350'
            }}>
              {message.text}
            </div>
          )}

          {/* <div>
            <label style={labelStyle}>Session Type</label>
            <select name="session_type" value={formData.session_type} onChange={handleChange} style={inputStyle}>
              <option value="Mock Trading">Mock Trading</option>
              <option value="Muhurat Trading">Muhurat Trading</option>
              <option value="Disaster Recovery (DR) Site">Disaster Recovery (DR) Site</option>
              <option value="Special Extension">Special Extension</option>
              <option value="Other">Other</option>
            </select>
          </div> */}

          <div>
            <label style={labelStyle}>Session Date</label>
            <input 
              type="date" name="date" required value={formData.date} onChange={handleChange} 
              min={new Date().toISOString().split("T")[0]} style={inputStyle} 
            />
          </div>

          <div style={{ display: 'flex', gap: '15px' }}>
            <div style={{ flex: 1 }}>
              <label style={labelStyle}>Start Time</label>
              <input type="time" name="start_time" required value={formData.start_time} onChange={handleChange} style={inputStyle} />
            </div>
            <div style={{ flex: 1 }}>
              <label style={labelStyle}>End Time</label>
              <input type="time" name="end_time" required value={formData.end_time} onChange={handleChange} style={inputStyle} />
            </div>
          </div>

          <div>
            <label style={labelStyle}>Additional Notes (Optional)</label>
            <input type="text" name="description" placeholder="e.g., Testing new strategy" value={formData.description} onChange={handleChange} style={inputStyle} />
          </div>

          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '10px' }}>
            <button type="button" onClick={onClose} style={cancelBtnStyle} disabled={loading}>Close</button>
            <button type="submit" style={submitBtnStyle} disabled={loading}>
              {loading ? 'Saving...' : 'Save Session'}
            </button>
          </div>
        </form>

        <div style={{ marginTop: '25px', paddingTop: '20px', borderTop: '1px solid #2e2e2e' }}>
          <h4 style={{ margin: '0 0 15px 0', color: '#fff', fontSize: '1rem' }}>Scheduled Sessions ({new Date().getFullYear()})</h4>
          
          {loadingSessions ? (
            <div style={{ color: '#b0b0b0', fontSize: '0.9rem', textAlign: 'center', padding: '10px 0' }}>Loading sessions...</div>
          ) : sessionsList.length > 0 ? (
            <div className="custom-scrollbar" style={{ maxHeight: '160px', overflowY: 'auto', paddingRight: '5px' }}>
              {sessionsList.map(session => (
                <div key={session.id} style={{ 
                  backgroundColor: '#2d2d2d', borderRadius: '6px', padding: '10px', 
                  marginBottom: '10px', borderLeft: '3px solid #2962FF' 
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px' }}>
                    <span style={{ color: '#fff', fontWeight: 'bold', fontSize: '0.95rem' }}>
                      {formatDate(session.date)}
                    </span>
                    
                    {/* NEW: Time and Delete Button Container */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <span style={{ color: '#26a69a', fontSize: '0.85rem', fontFamily: 'monospace' }}>
                        {session.start_time.slice(0, 5)} - {session.end_time.slice(0, 5)}
                      </span>
                      
                      {/* Delete Button */}
                      <button 
                        onClick={() => handleDelete(session.date)}
                        title="Delete this session"
                        style={{
                          background: 'none', border: 'none', cursor: 'pointer', 
                          fontSize: '1.1rem', padding: '0 5px', color: '#ef5350'
                        }}
                      >
                        🗑️
                      </button>
                    </div>

                  </div>
                  <div style={{ color: '#b0b0b0', fontSize: '0.85rem' }}>
                    {session.description}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div style={{ color: '#6c757d', fontSize: '0.9rem', fontStyle: 'italic', textAlign: 'center', padding: '10px 0' }}>
              No custom sessions scheduled for this year.
            </div>
          )}
        </div>

      </div>
    </div>
  );
};

// --- Inline Styles for matching Dark Theme ---
const overlayStyle = {
  position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.75)', zIndex: 1000,
  display: 'flex', justifyContent: 'center', alignItems: 'center'
};

const modalStyle = {
  backgroundColor: '#1e1e1e', border: '1px solid #404040',
  borderRadius: '12px', padding: '25px', width: '450px', 
  boxShadow: '0 10px 25px rgba(0,0,0,0.5)',
};

const headerStyle = {
  display: 'flex', justifyContent: 'space-between', alignItems: 'center',
  marginBottom: '20px', paddingBottom: '10px', borderBottom: '1px solid #2e2e2e'
};

const closeButtonStyle = {
  background: 'none', border: 'none', color: '#b0b0b0',
  fontSize: '1.2rem', cursor: 'pointer'
};

const labelStyle = {
  display: 'block', color: '#b0b0b0', fontSize: '0.85rem', marginBottom: '5px'
};

const inputStyle = {
  width: '100%', padding: '10px', borderRadius: '6px',
  border: '1px solid #404040', backgroundColor: '#2d2d2d',
  color: '#ffffff', boxSizing: 'border-box', colorScheme: 'dark' 
};

const cancelBtnStyle = {
  padding: '8px 16px', borderRadius: '6px', border: '1px solid #404040',
  backgroundColor: '#2d2d2d', color: '#fff', cursor: 'pointer'
};

const submitBtnStyle = {
  padding: '8px 16px', borderRadius: '6px', border: 'none',
  backgroundColor: '#2962FF', color: '#fff', cursor: 'pointer', fontWeight: 'bold'
};

export default SessionModal;